import classNames from 'classnames';
import * as H from 'history';
import React, { MouseEventHandler, ReactNode } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import './Link.pcss';

type Props = {
  href?: string;
  className?: string;
  isBlank?: boolean;
  rel?: string;
  download?: string;
  children?: ReactNode;
  to?: H.LocationDescriptor;
  capitalize?: boolean;
  onLinkClick?: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
} & React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLAnchorElement>,
  HTMLAnchorElement
>;

const SUPPORTED_SCHEMES = ['http', 'mailto:', 'tel:', 'data:', '/'];

export const isLink = (val = '') => {
  return SUPPORTED_SCHEMES.some(scheme => val.startsWith(scheme));
};

export const Link = ({
  className,
  href,
  to,
  isBlank,
  download,
  children,
  capitalize = true,
  onLinkClick,
  ...rest
}: Props) => {
  const classNameComputed = classNames(
    'c-link',
    {
      'c-link--capitalize': capitalize,
    },
    className,
  );

  if (to) {
    return (
      <RouterLink className={classNameComputed} to={to} onClick={onLinkClick}>
        {children}
      </RouterLink>
    );
  }

  const target = isBlank ? '_blank' : '_self';
  const isMatchingScheme = isLink(href);
  const adjustedHref = isMatchingScheme ? href : `//${href}`;

  return (
    <a
      className={classNameComputed}
      href={adjustedHref}
      target={target}
      download={download}
      {...rest}
    >
      {children}
    </a>
  );
};
